module.exports = __webpack_public_path__ + "img/DE02912.2f2492d8.png";